enum MutationKeys {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  UPDATE_SUB_USER = "UPDATE_SUB_USER",
  UPDATE_USER = "UPDATE_USER",
  UPDATE_PROMPT = "UPDATE_PROMPT",
  CREATE_PROMPT = "CREATE_PROMPT",
  UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION",
  DELETE_SUB_USER = "DELETE_SUB_USER",
  DELETE_MAIN_USER = "DELETE_MAIN_USER",
  UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION",
  UPDATE_B2B_ADMIN = "UPDATE_B2B_ADMIN",
  UPDATE_B2B_SUBSCRIPTION = "UPDATE_B2B_SUBSCRIPTION",
  UPDATE_B2B_ADMIN_PASS = "UPDATE_B2B_ADMIN_PASS",
  TOGGLE_SUBSCRIPTION_DISCOUNT = "TOGGLE_SUBSCRIPTION_DISCOUNT",
  UPDATE_ONE_TIME_NOTIFICATION = "UPDATE_ONE_TIME_NOTIFICATION",
  UPDATE_ONE_TIME_EMAIL = "UPDATE_ONE_TIME_EMAIL",
  PROCESS_AUTOMATION_FILE = "PROCESS_AUTOMATION_FILE",
  DOWNLOAD_AUTOMATION_RESULT = "DOWNLOAD_AUTOMATION_RESULT",
  UPDATE_AUTOMATION_PROMPT = "UPDATE_AUTOMATION_PROMPT",
  CANCEL_AUTOMATION_JOB = "CANCEL_AUTOMATION_JOB",
  UPSERT_CONSENT = "UPSERT_CONSENT",
  SEND_SG_TEMPLATE_EMAIL = "SEND_SG_TEMPLATE_EMAIL",
  UPDATE_SG_TEMPLATE = "UPDATE_SG_TEMPLATE",
  SEND_NOTIFICATION_MANAGEMENT = "SEND_NOTIFICATION_MANAGEMENT",
  LOG_OUT_ALL = "LOG_OUT_ALL",
}
export { MutationKeys };
